import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Stats from "@/components/site/Stats";
import Services from "@/components/site/Services";
import Roster from "@/components/site/Roster";
import Contact from "@/components/site/Contact";
import QRCodes from "@/components/site/QRCodes";
import Footer from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App grain bg-white">
        <Toaster position="bottom-right" theme="light" />
        <Nav />
        <main>
          <Hero />
          <EditorialMarquee />
          <About />
          <Stats />
          <Services />
          <Roster />
          <Contact />
          <QRCodes />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
